/* =========================================================================
   HIRA MODA - Warenkorb-Einschub (Cart Drawer) - mehrsprachig (de/en/ar)
   ========================================================================= */
(function () {
  if (window.__hmCartDrawer) return;
  window.__hmCartDrawer = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var LANG = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  var I18N = {
    de: { checking: 'Wird geprüft …', active: 'Gutschein aktiv', saved: 'Code gespeichert – er wird an der Kasse geprüft und angewendet.', fail: 'Das hat nicht geklappt. Bitte Code prüfen.' },
    en: { checking: 'Checking …', active: 'Discount applied', saved: 'Code saved – it will be checked and applied at checkout.', fail: 'That did not work. Please check the code.' },
    ar: { checking: 'جارٍ التحقق …', active: 'تم تطبيق الخصم', saved: 'تم حفظ الرمز – سيتم التحقق منه وتطبيقه عند الدفع.', fail: 'لم ينجح ذلك. يرجى التحقق من الرمز.' }
  };
  var T = I18N[LANG] || I18N.de;

  function animateCounters() {
    document.querySelectorAll('[data-hm-counter]').forEach(function (el) {
      if (el.dataset.hmDone) return;
      el.dataset.hmDone = '1';
      var target = parseInt(el.getAttribute('data-hm-counter'), 10) || 0;
      if (target <= 0) return;
      var cur = Math.max(0, target - 150);
      cur = cur - (cur % 10);
      el.textContent = cur.toLocaleString('de-DE');
      (function step() {
        cur += 10;
        if (cur >= target) cur = target;
        el.textContent = cur.toLocaleString('de-DE');
        if (cur < target) setTimeout(step, 30);
      })();
    });
  }

  function loadRecos() {
    document.querySelectorAll('[data-hm-recos]').forEach(function (box) {
      if (box.dataset.hmLoaded) return;
      var pid = box.getAttribute('data-hm-recos');
      var wrap = box.closest('[data-hm-recos-wrap]');
      if (!pid) { if (wrap) wrap.setAttribute('hidden', ''); return; }
      box.dataset.hmLoaded = '1';
      var url = ROOT + 'recommendations/products?product_id=' + encodeURIComponent(pid) +
        '&section_id=cart-recommendations&limit=6&intent=related';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var track = tmp.querySelector('.hm-recos__track');
          if (track && track.children.length) {
            box.innerHTML = '';
            box.appendChild(track);
            if (wrap) wrap.removeAttribute('hidden');
          } else if (wrap) {
            wrap.setAttribute('hidden', '');
          }
        })
        .catch(function () { if (wrap) wrap.setAttribute('hidden', ''); });
    });
  }

  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var bub = document.querySelector('#cart-icon-bubble');
      var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var fb = d2.querySelector('.shopify-section') || d2.body;
      if (bub && fb) bub.innerHTML = fb.innerHTML;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) cd.classList.remove('is-empty');
    initDynamic();
  }

  function openDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') cd.open();
  }

  function addVariant(id, btn) {
    if (!id) return;
    if (btn) { btn.classList.add('is-loading'); }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.sections) { applySections(res.sections); openDrawer(); }
      })
      .catch(function () {})
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function applyDiscount(code, wrap) {
    code = (code || '').trim();
    if (!code || !wrap) return;
    var msg = wrap.querySelector('[data-hm-voucher-msg]');
    var btn = wrap.querySelector('[data-hm-voucher-apply]');
    if (msg) { msg.textContent = T.checking; msg.className = 'hm-voucher__msg'; }
    if (btn) btn.disabled = true;

    var before = 0;
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        before = (c.cart_level_discount_applications || []).length;
        return fetch(ROOT + 'discount/' + encodeURIComponent(code), { headers: { 'Accept': 'text/html' } });
      })
      .then(function () {
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        applySections(res.sections);
        return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var apps = c.cart_level_discount_applications || [];
        var w2 = document.querySelector('[data-hm-voucher]');
        var m2 = w2 ? w2.querySelector('[data-hm-voucher-msg]') : msg;
        var b2 = w2 ? w2.querySelector('[data-hm-voucher-apply]') : btn;
        if (w2) w2.setAttribute('open', '');
        if (b2) b2.disabled = false;
        if (!m2) return;
        if (apps.length > before) {
          var saved = 0;
          apps.forEach(function (a) { saved += (a.total_allocated_amount || 0); });
          m2.textContent = T.active + (saved ? ' (−' + (saved / 100).toFixed(2).replace('.', ',') + ' €)' : '') + '.';
          m2.className = 'hm-voucher__msg is-ok';
        } else {
          m2.textContent = T.saved;
          m2.className = 'hm-voucher__msg';
        }
      })
      .catch(function () {
        var w2 = document.querySelector('[data-hm-voucher]');
        var m2 = w2 ? w2.querySelector('[data-hm-voucher-msg]') : msg;
        var b2 = w2 ? w2.querySelector('[data-hm-voucher-apply]') : btn;
        if (b2) b2.disabled = false;
        if (m2) { m2.textContent = T.fail; m2.className = 'hm-voucher__msg is-err'; }
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-hm-add]') : null;
    if (add) { e.preventDefault(); addVariant(add.getAttribute('data-hm-add'), add); return; }
    var vb = e.target.closest ? e.target.closest('[data-hm-voucher-apply]') : null;
    if (vb) {
      e.preventDefault();
      var wrap = vb.closest('[data-hm-voucher]');
      var inp = wrap ? wrap.querySelector('.hm-voucher__input') : null;
      applyDiscount(inp ? inp.value : '', wrap);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target && e.target.classList && e.target.classList.contains('hm-voucher__input') ? e.target : null;
    if (!inp) return;
    e.preventDefault();
    applyDiscount(inp.value, inp.closest('[data-hm-voucher]'));
  });

  function initDynamic() { animateCounters(); loadRecos(); }

  function boot() {
    initDynamic();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { initDynamic(); })
        .observe(cd, { childList: true, subtree: true });
      new MutationObserver(function () {
        if (cd.classList.contains('active')) initDynamic();
      }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* =========================================================================
   HIRA MODA - Feste deutsche Beschriftungen sprachabhaengig tauschen
   (Buttons, Bundle, Judge.me, Versand-/Rueckgabe-Block). Nur en/ar; de bleibt.
   Flexible Erkennung (Leerzeichen/Emoji egal) + dauerhafte Beobachtung.
   ========================================================================= */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  if (lang === 'de') return;
  var MAPS = {
    en: {
      exact: {
        'In den Warenkorb legen': 'Add to cart',
        'In den Warenkorb': 'Add to cart',
        'Jetzt kaufen': 'Buy it now',
        'Kundenbewertungen': 'Customer reviews',
        'Kunden sagen uns': 'What our customers say',
        'Bewertung schreiben': 'Write a review',
        'Schreiben Sie die erste Bewertung': 'Be the first to write a review',
        'Alle Bewertungen anzeigen': 'Show all reviews',
        'Höchste Bewertung': 'Highest rating',
        'Niedrigste Bewertung': 'Lowest rating',
        'Herbst Kollektion': 'Autumn Collection'
      },
      regex: [
        [/Gratis\s*Versand\s*ab\s*89\s*€?\s*\(\s*DE\s*\)/g, 'Free shipping from €89 (DE)'],
        [/Gratis\s*Versand\s*ab\s*89\s*€?/g, 'Free shipping from €89'],
        [/(\d+)\s*Tage\s*Rückgaberecht/g, '$1-day returns'],
        [/Versand\s*&\s*Rückgabe/g, 'Shipping & returns'],
        [/Ausverkauft/g, 'Sold out']
      ]
    },
    ar: {
      exact: {
        'In den Warenkorb legen': 'أضف إلى السلة',
        'In den Warenkorb': 'أضف إلى السلة',
        'Jetzt kaufen': 'اشترِ الآن',
        'Kundenbewertungen': 'آراء العملاء',
        'Kunden sagen uns': 'ماذا يقول عملاؤنا',
        'Bewertung schreiben': 'اكتب تقييمًا',
        'Schreiben Sie die erste Bewertung': 'كن أول من يكتب تقييمًا',
        'Alle Bewertungen anzeigen': 'عرض كل التقييمات',
        'Höchste Bewertung': 'الأعلى تقييمًا',
        'Niedrigste Bewertung': 'الأدنى تقييمًا',
        'Herbst Kollektion': 'مجموعة الخريف'
      },
      regex: [
        [/Gratis\s*Versand\s*ab\s*89\s*€?\s*\(\s*DE\s*\)/g, 'شحن مجاني من 89 € (DE)'],
        [/Gratis\s*Versand\s*ab\s*89\s*€?/g, 'شحن مجاني من 89 €'],
        [/(\d+)\s*Tage\s*Rückgaberecht/g, 'إرجاع خلال $1 يومًا'],
        [/Versand\s*&\s*Rückgabe/g, 'الشحن والإرجاع'],
        [/Ausverkauft/g, 'نفد المخزون']
      ]
    }
  };
  var M = MAPS[lang];
  if (!M) return;
  var EX = M.exact, RE = M.regex;
  function fixNode(t) {
    var raw = t.nodeValue;
    if (!raw) return;
    var key = raw.replace(/\s+/g, ' ').trim();
    if (EX.hasOwnProperty(key)) { t.nodeValue = raw.replace(key, EX[key]); return; }
    var v = raw;
    for (var i = 0; i < RE.length; i++) { v = v.replace(RE[i][0], RE[i][1]); }
    if (v !== raw) t.nodeValue = v;
  }
  function run() {
    try {
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) { fixNode(n); }
    } catch (e) {}
  }
  var pending = false;
  function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; run(); }, 250); }
  function boot() {
    run();
    try {
      new MutationObserver(function () { schedule(); })
        .observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    var i = 0;
    var iv = setInterval(function () { run(); if (++i >= 8) clearInterval(iv); }, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
